import { I18n } from '~/common/explicit-exports';
import { StyledSkipToMainLink } from './SkipToLink.styles';

export const SKIP_TO_MAIN_LINK_ID = 'main';

const TRANSLATED_SKIP_TO_LINK = I18n.t('common.community.layout.skip_to_link');

export const SkipToMainLink = () => (
  <StyledSkipToMainLink href={`#${SKIP_TO_MAIN_LINK_ID}`}>{TRANSLATED_SKIP_TO_LINK}</StyledSkipToMainLink>
);
